import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from 'styled-components';
import db from "../firebase";

import { doc, getDoc } from "firebase/firestore";



const Detail = (props) => {

    const { id } = useParams();
    const [detail, setDetailData] = useState({});

    useEffect(() => {
        fetchMovie();
    }, [id] );

    const fetchMovie = async () => {
        const docRef = doc(db, "movies", id);
        const docSnap = await getDoc(docRef);
    
        if (docSnap?.exists()) {
          console.log("Movie ->", docSnap.data());
          setDetailData(docSnap.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
    };

    // useEffect(() => {
    //     const docRef = db.collection('movies').doc(id);
    //     docRef.get().then((doc) => {
    //         if (doc.exists) {
    //             setDetailData(doc.data());
    //         } else {
    //             console.log("No such documents in Firebase...!");
    //         }
    //     })
    //     .catch((error) => {
    //         console.log("Error getting documents:", error);
    //     })
    // }, [id] );

    return (
        <Container>
            <Background>
                {
                    <img src={detail?.backgroundImg} alt={detail?.title} />
                }
            </Background>

            <ImageTitle>
                {
                    <img src={detail?.titleImg} alt={detail?.title} />
                }
            </ImageTitle>

            <ContentMeta>
                <Controls>
                    <Player>
                        <img src="/images/play-icon-black.png" alt="" />
                        <span>Play</span>
                    </Player>
                    <Trailer>
                        <img src="/images/play-icon-white.png" alt="" />
                        <span>Trailer</span>
                    </Trailer>
                    <AddList>
                        <span />
                        <span />
                    </AddList>
                    <GroupWatch>
                        <div>
                            <img src="/images/group-icon.png" alt="" />
                        </div>
                    </GroupWatch>
                </Controls>

                <SubTitle>
                    {detail?.subTitle}
                </SubTitle>

                <Description>
                    {detail?.description}
                </Description>
            </ContentMeta>
        </Container>
    );
};

const Container = styled.div`
    position: relative;
    min-height: calc(100vh-250px);
    overflow-x: hidden;
    display: block;
    top: 72px;
    padding; 0 calc(3.5vw+5px);
`;

const Background = styled.div`
    left: 0px;
    right: 0px;
    top: 0px;
    position: fixed;
    opacity: 0.8;
    z-index: -1;

    img {
        height: 100vh;
        width: 100vw;

        @media (max-width: 768px) {
            width: initial;
        }
    }
`;

const ImageTitle = styled.div`
    align-items: flex-end;
    display: flex;
    -webkit-box-pack: start;
    justify-content: flex-start;
    margin: 0px auto;
    height: 30vh;
    min-height: 170px;
    margin-top: 10%;       // modified
    padding-bottom: 24px;
    width: 100%;

    @media (max-width: 768px) {     // modified
        margin-top: 0;
    }

    img {
        max-width: 600px;
        min-width: 200px;
        width: 35vw;
        margin-left: 5%;        // modified
    }
`;

const ContentMeta = styled.div`
    max-width: 874px;
    margin-left: 5%;        // modified
`;

const Controls = styled.div`
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    margin: 24px 0px;
    min-height: 56px;
`;

const Player = styled.button`
    font-size: 15px;
    margin: 0 22px 0 0;
    padding: 0 24px;
    height: 56px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    letter-spacing: 1.8px;
    text-transform: uppercase;
    background: rgb(249, 249, 249);
    border: none;
    color: rgb(0, 0, 0);

    img {
        width: 32px;
    }

    &:hover {
        background: rgb(198, 198, 198);
    }

    @media (max-width: 768px) {
        height: 45px;
        padding: 0 12px;
        font-size: 12px;
        margin: 0 10px 0 0;

        img {
            width: 25px;
        }
    }
`;

const Trailer = styled(Player)`
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgb(249, 249, 249);
    color: rgb(249, 249, 249);

    &:hover {
        background-color: rgba(0, 0, 0, 0.6);
    }
`;

const AddList = styled.div`
    margin-right: 16px;
    height: 44px;
    width: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    border: 2px solid white;
    cursor: pointer;

    span {
        background-color: rgba(249, 249, 249);
        display: inline-block;

        &:first-child {
            height: 2px;
            transform: translate(1px, 0px) rotate(0deg);
            width: 16px;
        }

        &:nth-child(2) {
            height: 16px;
            transform: translateX(-8px) rotate(0deg);
            width: 2px;
        }
    }
`;

const GroupWatch = styled.div`
    height: 44px;
    width: 44px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: white;

    div {
        height: 40px;
        width: 40px;
        background: rgba(0, 0, 0, 0.9);
        border-radius: 50%;

        img {
            width: 100%;
        }
    }
`;

const SubTitle = styled.div`
    color: rgb(249, 249, 249);
    font-size: 16px;
    letter-spacing: 1px;
    min-height: 20px;

    @media (max-width: 768px) {
        font-size: 14px;
        line-height: 1.5em;
    }
`;

const Description = styled.div`
    line-height: 1.4;
    font-size: 18px;
    padding: 16px 0;
    color: rgb(249, 249, 249);

    @media (max-width: 768px) {
        font-size: 16px;
        padding: 25px 15px 0 0;
    }
`;

export default Detail;
